import React from 'react';
import { Shield } from 'lucide-react';

const PrivacyPage = ({ language }) => {
  // Common heading styles
  const h2Style = "text-3xl font-bold mt-10 mb-4";
  const h3Style = "text-2xl font-semibold mt-6 mb-3";
  const h4Style = "text-xl font-semibold mt-4 mb-2";
  const headingColor = { color: '#E53D4A' };

  const content = {
    de: {
      title: 'Datenschutzerklärung',
      sections: [
        {
          type: 'h2',
          text: '1. Datenschutz auf einen Blick'
        },
        {
          type: 'h3',
          text: 'Allgemeine Hinweise'
        },
        {
          type: 'p',
          text: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.'
        },
        {
          type: 'h3',
          text: 'Datenerfassung auf dieser Website'
        },
        {
          type: 'h4',
          text: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?'
        },
        {
          type: 'p',
          text: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.'
        },
        {
          type: 'h4',
          text: 'Wie erfassen wir Ihre Daten?'
        },
        {
          type: 'p',
          text: 'Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.'
        },
        {
          type: 'p',
          text: 'Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.'
        },
        {
          type: 'h4',
          text: 'Wofür nutzen wir Ihre Daten?'
        },
        {
          type: 'p',
          text: 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.'
        },
        {
          type: 'h4',
          text: 'Welche Rechte haben Sie bezüglich Ihrer Daten?'
        },
        {
          type: 'p',
          text: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.'
        },
        {
          type: 'p',
          text: 'Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.'
        },
        {
          type: 'h2',
          text: '2. Hosting'
        },
        {
          type: 'p',
          text: 'Wir hosten die Inhalte unserer Website bei folgendem Anbieter:'
        },
        {
          type: 'h3',
          text: 'IONOS'
        },
        {
          type: 'p',
          text: 'Anbieter ist die IONOS SE, Elgendorfer Str. 57, 56410 Montabaur (nachfolgend IONOS). Wenn Sie unsere Website besuchen, erfasst IONOS verschiedene Logfiles inklusive Ihrer IP-Adressen.'
        },
        {
          type: 'p',
          text: 'Die Verwendung von IONOS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website.'
        },
        {
          type: 'h2',
          text: '3. Allgemeine Hinweise und Pflichtinformationen'
        },
        {
          type: 'h3',
          text: 'Datenschutz'
        },
        {
          type: 'p',
          text: 'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.'
        },
        {
          type: 'h3',
          text: 'Hinweis zur verantwortlichen Stelle'
        },
        {
          type: 'p',
          text: 'Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:'
        },
        {
          type: 'address',
          lines: ['Martinez IT Systems', 'Felix Martinez', 'Georg-Weist-Straße 40', '93133 Burglengenfeld']
        },
        {
          type: 'contact',
          phone: '09471/9978600',
          mobile: '015569/104058',
          email: 'kontakt@martinez.systems'
        },
        {
          type: 'h3',
          text: 'Speicherdauer'
        },
        {
          type: 'p',
          text: 'Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.'
        },
        {
          type: 'h3',
          text: 'Widerruf Ihrer Einwilligung zur Datenverarbeitung'
        },
        {
          type: 'p',
          text: 'Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.'
        },
        {
          type: 'h3',
          text: 'Beschwerderecht bei der zuständigen Aufsichtsbehörde'
        },
        {
          type: 'p',
          text: 'Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde zu.'
        },
        {
          type: 'h3',
          text: 'Recht auf Datenübertragbarkeit'
        },
        {
          type: 'p',
          text: 'Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen.'
        },
        {
          type: 'h3',
          text: 'SSL- bzw. TLS-Verschlüsselung'
        },
        {
          type: 'p',
          text: 'Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.'
        },
        {
          type: 'h2',
          text: '4. Datenerfassung auf dieser Website'
        },
        {
          type: 'h3',
          text: 'Server-Log-Dateien'
        },
        {
          type: 'p',
          text: 'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:'
        },
        {
          type: 'list',
          items: ['Browsertyp und Browserversion', 'verwendetes Betriebssystem', 'Referrer URL', 'Hostname des zugreifenden Rechners', 'Uhrzeit der Serveranfrage', 'IP-Adresse']
        },
        {
          type: 'h3',
          text: 'Kontaktformular'
        },
        {
          type: 'p',
          text: 'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.'
        },
        {
          type: 'h3',
          text: 'Anfrage per E-Mail, Telefon oder Telefax'
        },
        {
          type: 'p',
          text: 'Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.'
        }
      ],
      source: 'Quelle'
    },
    en: {
      title: 'Privacy Policy',
      sections: [
        {
          type: 'h2',
          text: '1. Privacy at a Glance'
        },
        {
          type: 'h3',
          text: 'General Information'
        },
        {
          type: 'p',
          text: 'The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to personally identify you. For detailed information on data protection, please refer to our privacy policy listed below.'
        },
        {
          type: 'h3',
          text: 'Data Collection on This Website'
        },
        {
          type: 'h4',
          text: 'Who is responsible for data collection on this website?'
        },
        {
          type: 'p',
          text: 'Data processing on this website is carried out by the website operator. You can find their contact details in the "Information about the Responsible Party" section of this privacy policy.'
        },
        {
          type: 'h4',
          text: 'How do we collect your data?'
        },
        {
          type: 'p',
          text: 'Your data is collected in part by you providing it to us. This may include data that you enter into a contact form, for example.'
        },
        {
          type: 'p',
          text: 'Other data is collected automatically or with your consent when you visit the website by our IT systems. This is primarily technical data (e.g., internet browser, operating system, or time of page access). This data is collected automatically as soon as you enter this website.'
        },
        {
          type: 'h4',
          text: 'What do we use your data for?'
        },
        {
          type: 'p',
          text: 'Part of the data is collected to ensure error-free provision of the website. Other data may be used to analyze your user behavior. If contracts can be concluded or initiated via the website, the transmitted data will also be processed for contract offers, orders, or other order requests.'
        },
        {
          type: 'h4',
          text: 'What rights do you have regarding your data?'
        },
        {
          type: 'p',
          text: 'You have the right to receive free information about the origin, recipient, and purpose of your stored personal data at any time. You also have the right to request the correction or deletion of this data. If you have given consent to data processing, you can revoke this consent at any time for the future. You also have the right to request the restriction of the processing of your personal data under certain circumstances. Furthermore, you have the right to lodge a complaint with the competent supervisory authority.'
        },
        {
          type: 'p',
          text: 'You can contact us at any time regarding this and other questions on the subject of data protection.'
        },
        {
          type: 'h2',
          text: '2. Hosting'
        },
        {
          type: 'p',
          text: 'We host the content of our website with the following provider:'
        },
        {
          type: 'h3',
          text: 'IONOS'
        },
        {
          type: 'p',
          text: 'The provider is IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Germany (hereinafter IONOS). When you visit our website, IONOS collects various log files including your IP addresses.'
        },
        {
          type: 'p',
          text: 'The use of IONOS is based on Art. 6 para. 1 lit. f GDPR. We have a legitimate interest in the most reliable presentation of our website.'
        },
        {
          type: 'h2',
          text: '3. General Information and Mandatory Information'
        },
        {
          type: 'h3',
          text: 'Data Protection'
        },
        {
          type: 'p',
          text: 'The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the statutory data protection regulations and this privacy policy.'
        },
        {
          type: 'h3',
          text: 'Information about the Responsible Party'
        },
        {
          type: 'p',
          text: 'The responsible party for data processing on this website is:'
        },
        {
          type: 'address',
          lines: ['Martinez IT Systems', 'Felix Martinez', 'Georg-Weist-Straße 40', '93133 Burglengenfeld', 'Germany']
        },
        {
          type: 'contact',
          phone: '09471/9978600',
          mobile: '015569/104058',
          email: 'kontakt@martinez.systems'
        },
        {
          type: 'h3',
          text: 'Storage Duration'
        },
        {
          type: 'p',
          text: 'Unless a more specific storage period is mentioned within this privacy policy, your personal data will remain with us until the purpose for data processing ceases to apply.'
        },
        {
          type: 'h3',
          text: 'Revocation of Your Consent to Data Processing'
        },
        {
          type: 'p',
          text: 'Many data processing operations are only possible with your express consent. You can revoke consent you have already given at any time. The legality of the data processing carried out until the revocation remains unaffected by the revocation.'
        },
        {
          type: 'h3',
          text: 'Right to Lodge a Complaint with the Competent Supervisory Authority'
        },
        {
          type: 'p',
          text: 'In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority.'
        },
        {
          type: 'h3',
          text: 'Right to Data Portability'
        },
        {
          type: 'p',
          text: 'You have the right to have data that we process automatically on the basis of your consent or in fulfillment of a contract handed over to you or to a third party in a common, machine-readable format.'
        },
        {
          type: 'h3',
          text: 'SSL or TLS Encryption'
        },
        {
          type: 'p',
          text: 'This site uses SSL or TLS encryption for security reasons and to protect the transmission of confidential content. You can recognize an encrypted connection by the fact that the address line of the browser changes from "http://" to "https://" and by the lock symbol in your browser line.'
        },
        {
          type: 'h2',
          text: '4. Data Collection on This Website'
        },
        {
          type: 'h3',
          text: 'Server Log Files'
        },
        {
          type: 'p',
          text: 'The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:'
        },
        {
          type: 'list',
          items: ['Browser type and browser version', 'Operating system used', 'Referrer URL', 'Host name of the accessing computer', 'Time of the server request', 'IP address']
        },
        {
          type: 'h3',
          text: 'Contact Form'
        },
        {
          type: 'p',
          text: 'If you send us inquiries via the contact form, your details from the inquiry form, including the contact data you provided there, will be stored by us for the purpose of processing the inquiry and in case of follow-up questions.'
        },
        {
          type: 'h3',
          text: 'Inquiry by Email, Phone, or Fax'
        },
        {
          type: 'p',
          text: 'If you contact us by email, telephone, or fax, your inquiry including all resulting personal data will be stored and processed by us for the purpose of handling your request.'
        }
      ],
      source: 'Source'
    }
  };

  const c = content[language] || content.de;

  const renderSection = (section, index) => {
    switch (section.type) {
      case 'h2':
        return <h2 key={index} className={h2Style} style={headingColor}>{section.text}</h2>;
      case 'h3':
        return <h3 key={index} className={h3Style} style={headingColor}>{section.text}</h3>;
      case 'h4':
        return <h4 key={index} className={h4Style} style={headingColor}>{section.text}</h4>;
      case 'p':
        return <p key={index}>{section.text}</p>;
      case 'list':
        return (
          <ul key={index} className="list-disc pl-6 space-y-2">
            {section.items.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        );
      case 'address':
        return (
          <p key={index}>
            {section.lines.map((line, i) => (
              <React.Fragment key={i}>{line}<br /></React.Fragment>
            ))}
          </p>
        );
      case 'contact':
        return (
          <p key={index}>
            {language === 'de' ? 'Telefon' : 'Phone'}: {section.phone}<br />
            {language === 'de' ? 'Mobil' : 'Mobile'}: {section.mobile}<br />
            {language === 'de' ? 'E-Mail' : 'Email'}: {section.email}
          </p>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen py-16 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#E53D4A] text-white mb-4">
            <Shield className="h-8 w-8" />
          </div>
          <h1 className="text-5xl font-bold mb-4" style={{ color: '#E53D4A' }}>
            {c.title}
          </h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="text-gray-700 dark:text-gray-300 space-y-4 leading-relaxed">
            {c.sections.map((section, index) => renderSection(section, index))}
            
            <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {c.source}: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-[#E53D4A] hover:underline">https://www.e-recht24.de</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
